import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { CustomLink, SubTitle, Caption, styled, CommonStyles, Avatar } from '@teko/ds-desktop';
import { TickFilled } from '@teko/ds-icon';

const SellerCard = (_a) => {
    var { avatar, name, link, slogan, showSlogan = true, showTick = true, isAvatarHidden = false } = _a, rest = __rest(_a, ["avatar", "name", "link", "slogan", "showSlogan", "showTick", "isAvatarHidden"]);
    return (jsxs(Wrapper, Object.assign({}, rest, { children: [!isAvatarHidden && (jsx(StyledAvatar, Object.assign({ size: "l", borderColor: "divider", borderStyle: "solid" }, avatar), void 0)), jsxs("div", { children: [jsx(CustomLink, Object.assign({}, link, { children: jsxs(SubTitle, Object.assign({ level: 2, hoverColor: "primary500" }, { children: [name, showTick && !isAvatarHidden && (jsx(TickFilled, { color: "success500", size: 14, style: { marginLeft: '8px', marginBottom: '4px' } }, void 0))] }), void 0) }), void 0), showSlogan && slogan && (jsx(Caption, Object.assign({ level: 1, color: "textSecondary" }, { children: slogan }), void 0))] }, void 0)] }), void 0));
};
const Wrapper = styled.div `
  ${CommonStyles}
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: white;
  border-radius: 0.5rem;
`;
const StyledAvatar = styled(Avatar) `
  img {
    object-fit: contain;
  }
`;

export { SellerCard as S };
